import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { Outlet } from "react-router-dom";
import { StyledSuperAdminLayout } from "./styles";
import { Sidebar } from "@root/components/dashboard/sidebar";

const SuperAdminLayout: React.FC = () => {
  return (
    <StyledSuperAdminLayout>
      <Flex width={"100%"} minHeight={"100vh"} overflow={"auto"}>
        <Box height={"100%"} className="left-box">
          <Sidebar />
        </Box>
        <Box
          width={"100%"}
          height={"100%"}
          className="right-box"
          flex={1}
          position={"relative"}
          zIndex={1}
        >
          <Outlet />
        </Box>
      </Flex>
    </StyledSuperAdminLayout>
  );
};

export default SuperAdminLayout;
